<template>
  <div class="lottery-wheel" :class="cssType">
    <!-- {{ globalConfig.displayList }} 9999888 -->
    <FireworkCanvas2
      ref="fireworkCanvas2Ref"
      :isVisible="state.isVisible2"
      @animationComplete="handleAnimationComplete"
    />
  </div>
</template>
<script setup>
/* eslint-disable */
import { reactive, inject, defineExpose, ref } from 'vue'
import { isMobile } from '@/utils'
import SfActApi from '@/config/sfActApi'
import { useLog } from '@/composables/useLog'
import FireworkCanvas2 from '../../../FireworkCanvas/index2.vue'
const log = useLog()
const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH
const globalConfig = inject('globalConfig')
const getUserLotteryDetail = inject('getUserLotteryDetail')
const cssType = isMobile ? 'mobile' : 'pc'

const toggleLotteryRewardDialog = inject('toggleLotteryRewardDialog')
const fireworkCanvas2Ref = ref(null)

const state = reactive({
  activeIndex: -1,
  // rewardIndex: -1,
  rotateAngle: 0,
  isRotating: false,
  className: '',
  isVisible2: false
})

const handleAnimationComplete = () => {
  state.isVisible2 = false
}

const doLottery = async (skipAnimation = false) => {
  // 如果正在旋转，不执行
  if (state.isRotating) return
  state.isRotating = true
  
  const res = await SfActApi.lottery()
  console.log('lottery res', res)
  try {
    log.track('act_sf_lottery_once', {
      v1: res.lotteryRewardCode,
    })
  } catch (error) {
    console.error(error)
  }
  const lotteryRewardCode = res.lotteryRewardCode
  const currentItem = globalConfig.displayList.find(item => item.lotteryRewardCode === lotteryRewardCode)
  if (skipAnimation) {
    state.isRotating = false
    toggleLotteryRewardDialog(true, { rewards: [currentItem] }, (value) => {
      console.log('value', value)
    })
    getUserLotteryDetail()
    return
  }

  const index = globalConfig.displayList.findIndex(item => item.lotteryRewardCode === currentItem.lotteryRewardCode)
  // state.rewardIndex = currentItem.id
  console.log('currentItem.lotteryRewardCode', currentItem.lotteryRewardCode, index)
  state.className = ''
  setTimeout(() => {
    state.activeIndex = -1
    // state.className = 'rotate-' + index
    state.isVisible2 = true
    fireworkCanvas2Ref.value?.playSmallFirework()
    setTimeout(() => {
      state.isRotating = false
      toggleLotteryRewardDialog(true, { rewards: [currentItem] }, (value) => {
        console.log('value', value)
      })
      getUserLotteryDetail()
    }, 1500)
    setTimeout(() => {
      state.activeIndex = index
    }, 1000)
  }, 100)
}

const doLotteryOneKey = async (skipAnimation = false) => {
  // lotteryRewardCodeList
  // 如果正在旋转，不执行
  if (state.isRotating) return
  state.isRotating = true
  
  const res = await SfActApi.lotteryAll()
  console.log('lotteryAll res', res)
  try {
    log.track('act_sf_lottery_all', {
      v1: res.lotteryRewardCodeList.join(','),
    })
  } catch (error) {
    console.error(error)
  }
  const lotteryRewardCodeList = res.lotteryRewardCodeList
  const lotteryRewardCode = lotteryRewardCodeList[0]
  const currentItem = globalConfig.displayList.find(item => item.lotteryRewardCode === lotteryRewardCode)
  const currentItems = []
  lotteryRewardCodeList.forEach(item => {
    const displayItem = globalConfig.displayList.find(displayItem => displayItem.lotteryRewardCode === item)
    if (!displayItem) return
    currentItems.push(displayItem)
  })
  if (skipAnimation) {
    state.isRotating = false
    toggleLotteryRewardDialog(true, { rewards: currentItems }, (value) => {
      console.log('value', value)
    })
    getUserLotteryDetail()
    return
  }

  const index = globalConfig.displayList.findIndex(item => item.lotteryRewardCode === currentItem.lotteryRewardCode)
  // state.rewardIndex = currentItem.id
  console.log('currentItem.lotteryRewardCode', currentItem.lotteryRewardCode, index)
  state.className = ''
  setTimeout(() => {
    state.activeIndex = -1
    state.isVisible2 = true
    fireworkCanvas2Ref.value?.playLargeFirework()
    // state.className = 'rotate-' + index
    setTimeout(() => {
      state.isRotating = false
      toggleLotteryRewardDialog(true, { rewards: currentItems }, (value) => {
        console.log('value', value)
      })
      getUserLotteryDetail()
    }, 2500)
    setTimeout(() => {
      state.activeIndex = index
    }, 1500)
  }, 100)
}

defineExpose({
  doLottery,
  doLotteryOneKey
})

</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
